<template>
	<div class="container-large pb-4 pt-5">
		<transition
			name="fade"
			mode="out-in"
		>
			<div
				v-if="step === 'modality'"
				:key="step"
				class="d-flex flex-column align-items-center"
			>
				<h4>Selecione Módulo e Modalidade</h4>
				<div
					id="modules_and_modalities-dropdown"
					class="dropdown mb-0 mb-md-0 mt-3 px-3 pb-4"
					style="width: 100%; max-width: 450px"
				>
					<div
						class="scroll-container"
						style="overflow-y: auto"
					>
						<div
							class="d-flex flex-wrap flex-column modules-container pr-0"
							v-if="
								Object.keys(modules_and_modalities).length > 1
							"
						>
							<div class="form-check form-check-inline">
								<input
									id="modules_and_modalities_select_all"
									class="form-check-input"
									type="checkbox"
									v-model="modules_and_modalities.select_all"
									@change="
										ModuleChangeHandler(
											$event,
											'select_all'
										)
									"
								/>
								<label
									class="form-check-label"
									for="modules_and_modalities_select_all"
								>
									TODOS
								</label>
							</div>

							<hr class="my-2" />
							<ul
								class="mb-1"
								v-for="module in parsed_modules"
								:key="module.id"
							>
								<li class="mb-1 list-unstyled">
									<div
										class="d-flex justify-content-between position-relative"
									>
										<div
											class="form-check form-check-inline"
										>
											<input
												class="form-check-input"
												type="checkbox"
												:id="'ChkModule_' + module.id"
												:name="'ChkModule_' + module.id"
												:value="!!module.id"
												v-model="
													modules_and_modalities[
														`module_${module.id}`
													].selected
												"
												@change="
													ModuleChangeHandler(
														$event,
														module.id
													)
												"
											/>
											<label
												class="form-check-label"
												:for="'ChkModule_' + module.id"
											>
												{{ module.name }}
											</label>
										</div>
										<div
											class="chevron-expand-container"
											@click="
												modules_and_modalities[
													`module_${module.id}`
												].expanded =
													!modules_and_modalities[
														`module_${module.id}`
													].expanded
											"
										>
											<i
												class="chevron-expand fa fal"
												:class="{
													'fa-chevron-right':
														!modules_and_modalities[
															`module_${module.id}`
														].expanded,
													'fa-chevron-down':
														modules_and_modalities[
															`module_${module.id}`
														].expanded,
												}"
											>
											</i>
										</div>
									</div>
									<div
										class="mb-1 collapse"
										:id="'collapse_' + module.id"
										:class="{
											show: modules_and_modalities[
												`module_${module.id}`
											].expanded,
										}"
									>
										<ul
											v-for="modality in module.modalities"
											:key="modality.id"
										>
											<li class="list-unstyled ml-4 mb-1">
												<div
													class="form-check form-check-inline"
												>
													<input
														class="form-check-input modality-checkbox"
														type="checkbox"
														:id="
															'ChkModality_' +
															modality.id
														"
														:name="
															'ChkModality_' +
															modality.id
														"
														:value="modality.id"
														v-model="
															modules_and_modalities[
																`module_${module.id}`
															].modalities
														"
														@change="
															ModalityChangeHandler(
																$event,
																modality.id
															)
														"
													/>
													<label
														class="p-0 form-check-label modality-label"
														:for="
															'ChkModality_' +
															modality.id
														"
													>
														{{ modality.name }}
													</label>
												</div>
											</li>
										</ul>
									</div>
								</li>
							</ul>
						</div>
					</div>
				</div>
				<div
					class="col-12 text-center py-4"
					style="width: 450px"
				>
					<div class="d-flex justify-content-end">
						<button
							class="btn btn-primary px-md-5"
							v-if="hasSelectedModality"
							@click="FlowConfig"
						>
							continuar
						</button>
					</div>
				</div>
			</div>
			<div
				v-if="step === 'flow'"
				:key="step"
				class="pt-5 pb-3"
			>
				<Flow
					:label="'Fluxo'"
					:selected_modalities="selected_modalities"
					@next="WalkStep"
					@previous="step = 'modality'"
				/>
			</div>
		</transition>
	</div>
</template>

<script>
	const _ = require('lodash')
	import Modules from '@/components/shared/Modules'
	import Modalities from '@/components/shared/Modalities'
	import Flow from './components/Flow'
	import { mapActions, mapGetters } from 'vuex'
	import Swal from 'sweetalert2'
	export default {
		name: 'FlowWizard',
		components: {
			Modules,
			Modalities,
			Flow,
		},
		data() {
			return {
				selected_modalities: [],
				modules_and_modalities: {
					select_all: false,
				},
				step: 'modality',
				flow: {
					selected_action_buttons: [],
					user_list: [],
					selected_modalities: [],
				},
			}
		},
		computed: {
			...mapGetters('auth', ['requester_selected_id']),
			...mapGetters('system', ['modules', 'modalities']),
			parsed_modules() {
				return _.sortBy(this.modules, 'name').map(module => {
					return {
						...module,
						modalities: _.sortBy(
							this.modalities.filter(
								modality => modality.module_id == module.id
							),
							'name'
						),
					}
				})
			},
			hasSelectedModality() {
				return Object.keys(this.modules_and_modalities)
					.filter(key => key.startsWith('module_'))
					.some(
						key =>
							Array.isArray(
								this.modules_and_modalities[key].modalities
							) &&
							this.modules_and_modalities[key].modalities.length >
								0
					)
			},
		},
		watch: {
			step: {
				handler(val) {
					let hash = ''

					switch (val) {
						case 'modality':
							hash = '#modalidade'
							this.flow.user_list = null
							break
						case 'flow':
							hash = '#fluxos'
							break
					}

					window.location.hash = hash
				},
				immediate: true,
			},
			$route(to) {
				switch (to.hash) {
					case '#modalidade':
						this.step = 'modality'
						break
					case '#fluxos':
						this.step = 'flow'
						break
				}
			},
			'modules_and_modalities.select_all': {
				handler(val) {
					const modules_and_modalities = JSON.parse(
						JSON.stringify(this.modules_and_modalities)
					)

					for (const [index, module] of Object.entries(
						modules_and_modalities
					)) {
						if (index != 'select_all') {
							this.modules_and_modalities[index].selected = val

							if (val) {
								this.modules_and_modalities[index].modalities =
									this.modalities
										.filter(m => m.module_id == module.id)
										.map(m => m.id)
							} else {
								this.modules_and_modalities[index].modalities =
									[]
							}
						}
					}
				},
				deep: true,
			},
		},
		methods: {
			...mapActions('system', [
				'GetModulesAndModalities',
				'StartLoading',
				'FinishLoading',
			]),
			ModuleChangeHandler(event, module_id) {
				if (module_id === 'select_all') return

				if (!event.target.checked) {
					this.modules_and_modalities[
						`module_${module_id}`
					].modalities = []
				} else {
					if (
						!this.modules_and_modalities[`module_${module_id}`]
							.modalities.length
					) {
						this.modules_and_modalities[
							`module_${module_id}`
						].modalities = this.modalities
							.filter(m => m.module_id == module_id)
							.map(m => m.id)
					}
				}
			},
			ModalityChangeHandler(event, modality_id) {
				const modality = this.modalities.find(m => m.id == modality_id)

				if (event.target.checked) {
					this.modules_and_modalities[
						`module_${modality.module_id}`
					].selected = true
				} else {
					if (
						this.modules_and_modalities[
							`module_${modality.module_id}`
						].modalities.length === 0
					) {
						this.modules_and_modalities[
							`module_${modality.module_id}`
						].selected = false
					}
				}
			},
			FlowConfig() {
				const selected = []

				Object.keys(this.modules_and_modalities)
					.filter(key => key.startsWith('module_'))
					.forEach(key => {
						const module = this.modules_and_modalities[key]
						if (
							Array.isArray(module.modalities) &&
							module.modalities.length > 0
						) {
							selected.push(...module.modalities)
						}
					})
				this.selected_modalities = selected
				this.step = 'flow'
			},
			async WalkStep(selected_action_buttons, user_list) {
				switch (this.step) {
					case 'modality':
						this.step = 'flow'
						break
					case 'flow':
						this.flow.selected_action_buttons =
							selected_action_buttons
						this.flow.user_list = user_list

						await this.SaveFlow()
						break
				}
			},
			SaveFlow() {
				this.StartLoading()

				return window.api
					.call('post', '/save-flow', {
						account_id: this.requester_selected_id,
						selected_modalities: this.selected_modalities,
						selected_action_buttons:
							this.flow.selected_action_buttons,
						user_list: this.flow.user_list,
					})
					.then(({ data }) => {
						if (data.response) {
							Swal.fire({
								toast: true,
								position: 'top',
								title: 'Fluxo salvo com sucesso',
								icon: 'success',
								timer: 3000,
							})
						} else {
							Swal.fire({
								icon: 'error',
								title: 'Eita!',
								text: 'Houve um erro ao salvar o fluxo, contate o suporte.',
							})
						}
					})
					.finally(() => {
						this.FinishLoading()
					})
			},
		},
		async beforeMount() {
			await this.GetModulesAndModalities()
			this.modules.forEach(module => {
				this.$set(this.modules_and_modalities, `module_${module.id}`, {
					id: module.id,
					selected: false,
					expanded: false,
					modalities: [],
				})
			})
		},
	}
</script>

<style lang="css" scoped>
	.page {
		display: flex;
		flex-direction: column;
		align-items: center;
	}

	.chevron-expand-container {
		position: absolute;
		right: 0;
		top: 0;
		width: calc(100% - 13px);
		height: 24.02px;
		cursor: pointer;
		display: flex;
		align-items: center;
		justify-content: end;
	}

	#modules_and_modalities-dropdown {
		max-height: 950px !important;
		display: flex;
		flex-direction: column;
	}

	.modules-container {
		max-width: 410px;
	}

	.form-check-input {
		transform: scale(1.5);
	}

	.form-check-label {
		font-size: 18px;
		padding-left: 15px;
		color: white;
	}

	.form-check-inline {
		width: 100%;
		margin-right: 0;
	}

	.modality-checkbox {
		transform: scale(1.1);
	}

	.modality-label {
		font-size: 16px;
		color: #79caf6;
		padding-left: 15px !important;
	}

	.scroll-container {
		flex: 1;
		overflow-y: auto;
		padding-bottom: 10px;
	}
</style>
